import { colors } from '@/theme/colors';
import { CSSProperties } from 'react';
import useIsHovered from '@/common/hooks/use-is-hovered';
import useIsPressed from '@/common/hooks/use-is-pressed';

interface CancelProps {
  dark?: boolean;
  /** The color of the X. */
  color?: string;
  /** If true, a circle will be shown around the X on hover. */
  showCircle?: boolean;
  /** The color of the circle shown around the X. */
  circleColor?: string;
  width?: number;
  height?: number;
  style?: CSSProperties;
}

export default function Cancel({
  dark = false,
  color = dark ? colors.neutral100 : colors.neutral10,
  showCircle = false,
  circleColor = dark ? colors.neutral20 : colors.neutral85,
  width = showCircle ? 32 : 16,
  height = showCircle ? 32 : 16,
  style,
  ...rest
}: CancelProps) {
  const { isHovered, handleMouseEnter, handleMouseLeave } = useIsHovered();
  const { isPressed, handleMouseDown } = useIsPressed();

  /** Styles to apply when the checkbox is pressed. */
  const pressedStyles = isPressed ? { transform: 'scale(0.96)' } : {};

  return (
    <svg
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
      width={`${width}`}
      height={`${height}`}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={{ ...pressedStyles, ...style }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseDown={handleMouseDown}
    >
      {showCircle ? (
        <>
          {isHovered ? <circle cx="16" cy="16" r="16" fill={circleColor} /> : null}
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.95891 9.95967C10.3494 9.56915 10.9826 9.56915 11.3731 9.95967L22.0398 20.6263C22.4303 21.0169 22.4303 21.65 22.0398 22.0405C21.6493 22.4311 21.0161 22.4311 20.6256 22.0405L9.95891 11.3739C9.56838 10.9834 9.56838 10.3502 9.95891 9.95967Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.0409 9.95964C22.4315 10.3502 22.4315 10.9833 22.0409 11.3739L11.3743 22.0405C10.9838 22.431 10.3506 22.431 9.96006 22.0405C9.56954 21.65 9.56954 21.0168 9.96006 20.6263L20.6267 9.95964C21.0173 9.56912 21.6504 9.56912 22.0409 9.95964Z"
            fill={color}
          />
        </>
      ) : (
        <g id="ic-close">
          <path
            id="Vector 12"
            d="M3.12762 2.66675L14.1915 13.3334"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector 13"
            d="M14.1915 2.66675L3.12764 13.3334"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      )}
    </svg>
  );
}
